import { Badge } from "@/components/ui/badge";
import type { ProgramNewsUpdate } from "@/services/adminProgramNews";
import { classBadgeVariant } from "./deliveryClass";
import { GLOSSARY, type GlossaryKey } from "./glossary";
import Term from "./Term";
import { formatConfidence } from "./formatters";

interface EventBadgesProps {
  update: ProgramNewsUpdate;
}

/** Class, type, confidence and verification badges shared by the card and the detail. */
const EventBadges = ({ update }: EventBadgesProps) => (
  <>
    <Badge variant={classBadgeVariant(update.deliveryClass)}>
      <Term term={update.deliveryClass}>{update.deliveryClass}</Term>
    </Badge>
    {update.type ? (
      <Badge variant="outline">
        {update.type in GLOSSARY ? (
          <Term term={update.type as GlossaryKey}>{update.type}</Term>
        ) : (
          update.type
        )}
      </Badge>
    ) : null}
    {typeof update.confidence === "number" ? (
      <span className="text-muted-foreground">{formatConfidence(update.confidence)}</span>
    ) : null}
    {update.evidenceHash ? (
      <Badge variant="secondary" title="The event was checked against the article body">
        verified by article body
      </Badge>
    ) : null}
  </>
);

export default EventBadges;
